import PropTypes from 'prop-types';
import { TextField, InputAdornment } from '@mui/material';
import Iconify from '../../../components/iconify';

export default function PokemonSearch({ onSearchChange }) {
  const handleChange = (event) => {
    if (onSearchChange) {
      onSearchChange(event.target.value);
    }
  };

  return (
    <TextField
      fullWidth
      placeholder="Search by name or number..."
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
          </InputAdornment>
        ),
      }}
    />
  );
}

PokemonSearch.propTypes = {
  onSearchChange: PropTypes.func,
};
